export default __webpack_public_path__ + "static/media/butter2.ece232d1.jpg";